import { useCallback, useState } from 'react';
import ChatHeader from './ChatHeader';
import ChatList from './ChatList';
import ChatMessages from './ChatMessages';
import Delivery from './Delivery/Delivery';
import MessageInput from './Input';
import Marketplace from './Marketplace';
import Promo from './Promo';
import Settings from './Settings';
import Sidebar from './Sidebar';

const Web = ({ chat, chats, selectedChatId, setSelectedChatId, highlightedChatId }) => {
  const [mode, setMode] = useState('chat');

  const render = useCallback(() => {
    switch (mode) {
      case 'chat':
        return (
          <div className='content-container'>
            <ChatList
              chats={chats}
              selectedChatId={selectedChatId}
              setSelectedChatId={setSelectedChatId}
              highlightedChatId={highlightedChatId}
            />
            {chat && (
              <div className='chat-container'>
                <ChatHeader chat={chat} />
                <ChatMessages chatId={chat.id} messages={chat?.messages || []} />
                <MessageInput chat={chat} />
              </div>
            )}
          </div>
        );
      case 'market':
        return <Marketplace />;
      case 'promocodes':
        return <Promo />;
      case 'delivery':
        return <Delivery />;
      case 'settings':
        return <Settings />;
      default:
        return <></>;
    }
  }, [chat, chats, mode, selectedChatId, setSelectedChatId, highlightedChatId]);

  return (
    <div className='App'>
      <Sidebar mode={mode} setMode={setMode} />
      {render()}
    </div>
  );
};

export default Web;
